import { render } from "./ProductSelectionGrid.vue?vue&type=template&id=5566362a&scoped=true"
import script from "./ProductSelectionGrid.vue?vue&type=script&lang=js"
export * from "./ProductSelectionGrid.vue?vue&type=script&lang=js"

import "./ProductSelectionGrid.vue?vue&type=style&index=0&id=5566362a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5566362a"]])

export default __exports__